<div *ngIf="!hasSelectedEquipmentType">
  <input
    class="input-legacy"
    type="text"
    placeholder="Pesquisar por tipo"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedEquipmentType()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let equipmentType of equipmentsType" [value]="equipmentType.id">
      {{ equipmentType.name }}
    </mat-option>
    <mat-option *ngIf="!equipmentsType.length"> Nenhum tipo de equipamento encontrado </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="hasSelectedEquipmentType">
  <input class="input-legacy" disabled type="text" [value]="selectedEquipmentType.name" />

  <button
    mat-icon-button
    class="cancel-button accent-700-fg"
    *ngIf="hasSelectedEquipmentType"
    (click)="deselectEquipmentType()"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</div>
